import { TermsService } from "../services/TermsAndConditions";

export const GetTerms = async () => {
  const data = await TermsService.GetTerms();
  console.log(data);
  return data;
};
